module.exports = __webpack_public_path__ + "static/img/penny_pictgrid20_960x870.e100d35.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/penny_pictgrid20_960x870.jpg
// module id = nmWq
// module chunks = 0